export default __webpack_public_path__ + "static/media/global.1ed5fde9.svg";